export const BASE_I18NEXT_KEY = 'i18nextLng';
